import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandingContext = createContext({ logo: null, favicon: null, refresh: () => {} });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({ logo: null, favicon: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/config/branding");
      setBranding({ logo: data.logo || null, favicon: data.favicon || null });
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = branding.favicon || "/favicon.ico";
  }, [branding.favicon]);

  return (
    <BrandingContext.Provider value={{ ...branding, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
